module.exports = __webpack_public_path__ + "static/media/slide3-m.bef4f326.png";